// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/chunks/" + ({"5996":"8d06a44d","6831":"0b02c20c","8503":"f68e9ce8"}[chunkId] || chunkId) + "." + {"5996":"85e0ea122b264f76","6831":"8b76c1407c6318cb","8503":"802dbdba35d5f2c4","9683":"f582650b196a33d3"}[chunkId] + ".js";
};